import React from "react";

/* Rail color map — single source of truth for SWIFT/SEPA/USDC/etc.
   keep in sync with terminal.css --rail-* tokens. */
export const RAIL = {
  SWIFT:    { color: "var(--rail-swift)",   label: "SWIFT"  },
  Wire:     { color: "var(--rail-swift)",   label: "WIRE"   },
  SEPA:     { color: "var(--rail-sepa)",    label: "SEPA"   },
  "SEPA-I": { color: "var(--rail-sepa)",    label: "SEPA-I" },
  ACH:      { color: "var(--rail-ach)",     label: "ACH"    },
  FedNow:   { color: "var(--rail-fednow)",  label: "FEDNOW" },
  FPS:      { color: "var(--rail-sepa)",    label: "FPS"    },
  USDC:     { color: "var(--rail-onchain)", label: "USDC"   },
  USDT:     { color: "var(--rail-onchain)", label: "USDT"   },
  BTC:      { color: "var(--rail-onchain)", label: "BTC"    },
  ETH:      { color: "var(--rail-onchain)", label: "ETH"    },
  FX:       { color: "var(--rail-fx)",      label: "FX"     },
  CARD:     { color: "var(--rail-card)",    label: "CARD"   },
  Internal: { color: "var(--term-ink-2)",   label: "INTERNAL" },
};

export default function RailTag({ rail }) {
  const r = RAIL[rail] || { color: "var(--term-ink-2)", label: String(rail || "—").toUpperCase() };
  return (
    <span className="term-rail-tag" style={{ color: r.color }}>{r.label}</span>
  );
}
